import GradientBottom from '../../../../shared/assets/images/png/gradientBottom.png';
import styled from 'styled-components';
import withImage from '../../../../shared/components/utils/hoc/withImage';

const PilotGradientBottom = styled.img<React.CSSProperties>`
  bottom: 0;
  opacity: ${(props) => props.opacity || 1};
  overflow: hidden;
  position: absolute;
  width: 100%;
  z-index: 1;
`;

PilotGradientBottom.defaultProps = {
  src: GradientBottom,
};

export default withImage(PilotGradientBottom, false);
